import React, { useContext, useState } from "react";
import { Title } from "../../../../../../stories/Title/Title";
import Close from "../../../../../../images/Close.svg";
import { Tab, Tabs } from "@mui/material";
import { a11yProps, TabPanel } from "../../../../../../styles/Tabs";
import Arrow from "../../../../images/Next.svg";
import AssetsList from "./AssetsList";
import AssetSummaryTable from "../../../reports/assetwise/AssetSummaryTable";
import { AppContext } from "../../../../../../context/context";

interface Props {
  setDetailAssets: React.Dispatch<React.SetStateAction<boolean>>;
}

const Index = ({ setDetailAssets }: Props) => {
  const [value, setValue] = useState(0);
  const { state } = useContext(AppContext)
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  return (
    <>
      <div className="particular-asset">
        <div className="particular-asset__title">
          <Title>{state.itmDesc}</Title>
          <img src={Close} alt="" onClick={() => setDetailAssets(false)} />
        </div>
        <div className="particular-asset__block">
          <div className="particular-asset__block--tabs row g-0">
            <div className="col">
              <Tabs value={value} onChange={handleChange}>
                <Tab label="Assets List" value={0} {...a11yProps(0)} />
                <Tab label="Count Summary" value={1} {...a11yProps(1)} />
              </Tabs>
            </div>
          </div>
          <div className="particular-asset__block--tabpanel row g-0">
            <TabPanel value={value} index={0}>
              <AssetsList setDetailAssets={setDetailAssets}/>
            </TabPanel>
            <TabPanel value={value} index={1}>
              <div className="particular-asset__count-summary">
                <AssetSummaryTable setDetailAssets={setDetailAssets} />
              </div>
            </TabPanel>
          </div>
        </div>
      </div>
    </>
  );
};

export default Index;
